import type { ServiceItem } from '@ngb-frontend/shared/types'

export const universalSrvToLegacy = (srvItems?: ServiceItem[]) => {
  if (!srvItems) return

  return srvItems.map((srvItem) => {
    if (srvItem.code === 'PickupAndReturn') {
      return { code: 'CollectAndReturn', value: 'CollectAndReturn' }
    } else return srvItem
  })
}

export const legacySrvToUniversal = (srvItems?: ServiceItem[]) => {
  if (!srvItems) return

  return srvItems.map((srvItem) => {
    if (srvItem.code === 'CollectAndReturn') {
      return { code: 'PickupAndReturn', value: 'PickupAndReturn' }
    } else return srvItem
  })
}
